import { render, staticRenderFns } from "./PointDefinition.vue?vue&type=template&id=6a58535e"
import script from "./PointDefinition.vue?vue&type=script&lang=ts"
export * from "./PointDefinition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports